export default __webpack_public_path__ + "static/media/Cheng-Ho Battle Stave.2c9c6b66.jpg";